import { defineMessages } from "react-intl";

export const messages = defineMessages({
    summarySectionTitle: {
        id: "fastshift.dashboard.summary-section.title",
        defaultMessage: "Summary",
        description: "Title for the summary section"
    },
    dataCenterCardHeading: {
        id: "fastshift.dashboard.data-center-card.heading",
        defaultMessage: "Data Center instances assessed",
        description: "Heading for the data center summary card"
    },
    areaImprovementCardHeading: {
        id: "fastshift.dashboard.area-improvement-card.heading",
        defaultMessage: "Areas to improve",
        description: "Heading for the area improvement summary card"
    },
    deletedAppsCardHeading: {
        id: "fastshift.dashboard.deleted-apps-card.heading",
        defaultMessage: "Deleted apps",
        description: "Heading for the deleted apps summary card"
    },
    migrationCompletedCardHeading: {
        id: "fastshift.dashboard.migration-completed-card.heading",
        defaultMessage: "Migrations completed",
        description: "Heading for the migration completed summary card"
    },
    migrationInProgressCardHeading: {
        id: "fastshift.dashboard.migration-running-card.heading",
        defaultMessage: "Migrations in progress",
        description: "Heading for the migration in progress summary card"
    },
    unsuccessfulMigrationCardHeading: {
        id: "fastshift.dashboard.unsuccessful-migration-card.heading",
        defaultMessage: "Unsuccessful migrations",
        description: "Heading for the unsuccessful migration summary card"
    },
    viewMigrations: {
        id: "fastshift.dashboard.organisation-summary.view-migrations",
        defaultMessage: "View migrations",
        description: "Button text to view migrations in the migration summary"
    },
    viewAssessments: {
        id: "fastshift.dashboard.organisation-summary.view-assessments",
        defaultMessage: "View assessments",
        description: "Button text to view assessments in the migration summary"
    }
});
